import { NavItem } from "@/components/AppMenu/AppMenu";
import homeIcon from "@assets/icons/menu-icon-home.svg"
import infoIcon from "@assets/icons/menu-icon-info.svg"
import mapIcon from "@assets/icons/menu-icon-map.svg"
import quizIcon from "@assets/icons/menu-icon-quiz.svg"
import roomsIcon from "@assets/icons/menu-icon-rooms.svg"

/**
 * Route paths - single source of truth for all route constants
 * Used throughout the app for navigation, links, and visibility logic
 */
export const ALL_ROUTES = {
  basePath: '/',
  rooms: '/rooms',
  room: '/rooms/:id',
  artwork: '/artwork/:id',
  feed: '/feed/:id',
  map: '/map',
  quiz: '/quiz',
  stepQuiz: '/quiz/:id',
  endRoom: '/end-tour',
  endQuiz: 'endQuiz',
  info: '/info',
  accessibility: '/accessibility',

  test: '/test',
} as const;

/**
 * Page titles mapping for i18n
 * Used by AppLayout to display dynamic page titles
 */
export const PAGE_TITLES: Record<string, string> = {
  [ALL_ROUTES.basePath]: 'pages.home.title',
  [ALL_ROUTES.room]: 'pages.room.title',
  [ALL_ROUTES.info]: 'pages.info.title',
  [ALL_ROUTES.accessibility]: 'pages.accessibility.title',
}

/**
 * Get i18n key for page title from current pathname
 */
export function getTitleFromPath(pathname: string): string {
  return PAGE_TITLES[pathname] || ''
}

/**
 * Navigation menu items configuration
 * Defines which routes show the bottom navigation menu
 */
const baseNavItems: NavItem[] = [
  { id: 'home', labelKey: 'nav.home', path: ALL_ROUTES.basePath, icon: homeIcon },
  { id: 'map', labelKey: 'nav.map', path: ALL_ROUTES.map, icon: mapIcon },
  { id: 'rooms', labelKey: 'nav.rooms', path: ALL_ROUTES.rooms, icon: roomsIcon },
  { id: 'quiz', labelKey: 'nav.quiz', path: ALL_ROUTES.quiz, icon: quizIcon },
  { id: 'info', labelKey: 'nav.info', path: ALL_ROUTES.info, icon: infoIcon },
];

export const NAV_ITEMS: NavItem[] = [
  ...baseNavItems,
  ...(import.meta.env.DEV ? [{ id: 'test', labelKey: 'nav.test', path: ALL_ROUTES.test, icon: infoIcon }] :
    []),
];
